<template>
  <div
    class="Overlay"
    @click.self="closeModal"
    v-if="visible"
  >
    <div class="ModalBox ModalBox--central Modal--filters">
      <div class="ModalBox-header d-flex justify-content-between align-items-center position-absolute p-3">
        <div class="Tit Tit--modal position-absolute w-100">
          {{$t('customer_edit_fiscal_address_modal_header')}}
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#close-icon"></use>
          </svg>
        </div>

      </div>
      <div class="ModalBox-container position-relative pl-3 pr-5 pt-3">
        <form class="my-5">
          <div class="row">
            <div class="col-12">
              <i18n
                tag="span"
                path="company_update_company_fiscal_address_info"
                class="Fuell-Text ml-2"
              >
                <template v-slot:customerName>
                  <span class="Fuell-Text text-danger">{{customer.name}}</span>
                </template>
              </i18n>
            </div>
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('ADDRESS').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  :class="{'Form--field-error': $v.office.fiscalAddress.$error}"
                ><input
                    type="text"
                    name=""
                    id=""
                    v-model="office.fiscalAddress"
                    @blur="$v.office.fiscalAddress.$touch()"
                    :placeholder="$t('ADDRESS_PLACEHOLDER')"
                    class="Input-text"
                  ></div>
              </div>
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('ZIP').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  :class="{'Form--field-error': $v.office.fiscalZipCode.$error}"
                ><input
                    type="text"
                    name=""
                    id=""
                    v-model="office.fiscalZipCode"
                    @blur="$v.office.fiscalZipCode.$touch()"
                    :placeholder="$t('ZIP')"
                    class="Input-text"
                  ></div>
              </div>
              <div
                class="input--block input--block--margin input--block--padded"
                v-if="countries.length > 0"
              >
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('COUNTRY').toUpperCase()}}</label>
                <multi-select-input
                  :options="countries"
                  :placeholder="'COUNTRY'"
                  :value="office.fiscalCountry"
                  @inputSelected="setCountry($event)"
                  @close="$v.office.fiscalCountry.$touch()"
                />
              </div>
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('STATE').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  :class="{'Form--field-error': $v.office.fiscalState.$error}"
                ><input
                    type="text"
                    name=""
                    id=""
                    v-model="office.fiscalState"
                    @blur="$v.office.fiscalState.$touch()"
                    :placeholder="$t('STATE')"
                    class="Input-text"
                  ></div>
              </div>

              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('CITY').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  :class="{'Form--field-error': $v.office.fiscalCity.$error}"
                ><input
                    type="text"
                    name=""
                    id=""
                    v-model="office.fiscalCity"
                    @blur="$v.office.fiscalCity.$touch()"
                    :placeholder="$t('CITY')"
                    class="Input-text"
                  ></div>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div class="ModalBox-footer d-flex justify-content-center my-3">
        <button
          v-if="!isCallingOffice"
          class="Fuell-Button block blue w-50"
          :disabled="isCallingOffice || $v.$invalid"
          :class="{'disabled' : isCallingOffice || $v.$invalid}"
          @click="showConfirmModal"
        >
          {{$t('ACTION_SEND')}}
        </button>
        <spinner v-else />
      </div>
    </div>
    <confirm-modal
      :open.sync="showConfirmModalFlag"
      v-if="showConfirmModalFlag"
      :extraInfo="true"
      :message="''"
      @accept="editOffice"
      :title="'customer_edit_fiscal_address_modal_header'"

      :acceptText="'customer_edit_address_confirm'"
      :dismissText="'ACTION_CANCEL'"
    >

      <template v-slot:additional>
        <i18n
          tag="p"
          class="Fuell-Text"
          path="company_update_company_fiscal_address_warning"
        >
          <template v-slot:customerName>
            <span class="Fuell-Text text-link">{{customer.name}}</span>
          </template>
        </i18n>

        <div class="row">
          <div class="col-6">
            <span class="Fuell-Text">{{$t('ADDRESS')}}</span>
          </div>
          <div class="col-6">
            <span class="Fuell-Text text-link">{{office.fiscalAddress}}</span>

          </div>
          <div class="col-6">
            <span class="Fuell-Text">{{$t('Código postal')}}</span>
          </div>
          <div class="col-6">
            <span class="Fuell-Text text-link">{{office.fiscalZipCode}}</span>

          </div>

          <div class="col-6">
            <span class="Fuell-Text">{{$t('COUNTRY')}}</span>
          </div>
          <div class="col-6">

            <span class="Fuell-Text text-link">{{office.fiscalCountry.name}}</span>
          </div>
          <div class="col-6">
            <span class="Fuell-Text">{{$t('STATE')}}</span>
          </div>
          <div class="col-6">
            <span class="Fuell-Text text-link">{{office.fiscalState}}</span>

          </div>
          <div class="col-6">
            <span class="Fuell-Text">{{$t('CITY')}}</span>
          </div>
          <div class="col-6">

            <span class="Fuell-Text text-link">{{office.fiscalCity}}</span>
          </div>
        </div>
      </template>

    </confirm-modal>
  </div>

</template>

<script>
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import officeApi from '@/modules/company/_api'
import ConfirmModal from '@/components/Commons/ConfirmModal'
import Spinner from '@/components/Commons/Spinner'
import { isEmpty } from 'lodash-es'
// import { latinAlpha, latinAlphaNumeric } from '@/utils/customValidations'
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')
export default {
  name: 'CustomerEditFiscalAddressModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: { MultiSelectInput, ConfirmModal, Spinner },
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      office: {
        fiscalAddress: '',
        fiscalState: '',
        fiscalZipCode: '',
        fiscalCity: '',
        fiscalCountry: {}

      },
      isCallingOffice: false,
      showConfirmModalFlag: false
    }
  },
  computed: {
    publicConfig () {
      return this.$store.getters['ConfigStore/publicConfig']
    },
    countries () {
      return !isEmpty(this.publicConfig) ? this.$store.getters['ConfigStore/publicConfig'].countries.filter(el => el.shippingAddressEnabled) : []
    },
    officeId () {
      return this.customer?.offices[0]?.id || 0
    }
  },
  methods: {
    setCountry (value) {
      this.office.fiscalCountry = this.countries.find(el => el.id === value)
    },
    showConfirmModal () {
      this.showConfirmModalFlag = true
    },
    async fetchOffice () {
      if (this.isCallingOffice) return

      try {
        this.isCallingOffice = true
        const { data } = await officeApi.getOffice(this.officeId)
        const { fiscalAddress, fiscalZipCode, fiscalCity, fiscalState, fiscalCountry } = data
        this.office.fiscalAddress = fiscalAddress
        this.office.fiscalZipCode = fiscalZipCode
        this.office.fiscalCity = fiscalCity
        this.office.fiscalState = fiscalState
        this.office.fiscalCountry = fiscalCountry
      } catch (error) {
        this.$store.dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'company_fetch_company_error' },
          { root: true }
        )
      } finally {
        this.isCallingOffice = false
      }
    },
    async editOffice () {
      if (this.isCallingOffice) return
      try {
        this.isCallingOffice = true
        await officeApi.putOffice(this.officeId, this.office)
        this.$store.dispatch('SnackBars/addSuccess', this.$i18n.t('company_update_company_information_success'), { root: true })
        this.closeModal()
      } catch (error) {
        this.$store.dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'company_update_company_information_error' },
          { root: true }
        )
      } finally {
        this.isCallingOffice = false
      }
    }
  },
  async created () {
    await this.fetchOffice()
  },
  validations: {
    office: {
      fiscalAddress: { required },
      fiscalZipCode: { required },
      fiscalCountry: { required },
      fiscalCity: { required },
      fiscalState: { required }

    }
  }

}
</script>

<style scoped>
.text-link {
  color: var(--semantic-alert-main);
}
.Overlay {
  z-index:2000;
}
.ModalBox-header {
  z-index:2000;
}

</style>
